module.exports = __webpack_public_path__ + "assets/images/0891c50958717059f4ef3939861f6acd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/ccc-himss-ipad/ccc-himss-ipad-0.jpg
// module id = 803
// module chunks = 0